// Do not edit.
import { ShaderStore } from "../Engines/shaderStore";

const name = "lightProxyPixelShader";
const shader = `flat varying vOffset: u32;
flat varying vMask: u32;
uniform tileMaskResolution: vec3f;
var<storage,read_write> tileMaskBuffer: array<atomic<u32>>;
@fragment
fn main(input: FragmentInputs)->FragmentOutputs {let maskResolution=vec2u(uniforms.tileMaskResolution.yz);let tilePosition=vec2u(fragmentInputs.position.xy);let tileIndex=(tilePosition.x*maskResolution.x+tilePosition.y)*maskResolution.y+fragmentInputs.vOffset;atomicOr(&tileMaskBuffer[tileIndex],fragmentInputs.vMask);}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}

/** @internal */
export const lightProxyPixelShaderWGSL = { name, shader };
